import React from 'react'
import _ from "underscore";

const Lists  = function(props){
    const childBlocks = _.values(props.blocks).map((Block, id) => <Block.component context={props.context} key={id}/>);

    if (childBlocks.length > 0) {
        return (
            <category name='Lists' id='lists' iconclass='category with-icon-paths snap-icon-list2_dual'>
                <label text="Lists"></label>
                { childBlocks }
            </category>
        );
    }
    
    return null;
}

export default Lists;